module.exports = __webpack_public_path__ + "Microsoft_JhengHei.a09be68b956f5d89f27e.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Microsoft_JhengHei.ttf
// module id = ./src/assets/fonts/Microsoft_JhengHei.ttf
// module chunks = 2